var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegramHeader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.00783647 16.4855C0.00886129 17.2029 0.74259 17.6859 1.40191 17.4032L18.8565 9.91908C19.6644 9.57267 19.6644 8.42733 18.8565 8.08092L1.40191 0.596818C0.74259 0.314117 0.00886129 0.797092 0.00783647 1.51447L0.00125254 6.12322C0.000535762 6.62497 0.371743 7.04957 0.869088 7.11588L7.56579 8.00877C8.72291 8.16305 8.72291 9.83695 7.56579 9.99123L0.869087 10.8841C0.371742 10.9504 0.00053576 11.375 0.00125254 11.8768L0.00783647 16.4855Z",
    fill: "#FF0056"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramHeader);
export default __webpack_public_path__ + "static/media/TelegramHeader.626a917db19f991fae0b1f4fa3293805.svg";
export { ForwardRef as ReactComponent };